import React from "react";

const JQuery_Get_Started = () => {
  return (
    <div>
      <h1>JQuery_Get_Started</h1>
      <p>Placeholder component for: "JQuery_Get_Started"</p>
    </div>
  );
};

export default JQuery_Get_Started;
